<template>
	<div class="sf-datatable-wrapper">
		<div class="sf-datatable-container">
			<div class="sf-table">
				<table class="qms-table">
					<tbody>
						<tr>
							<!-- 검증내용 -->
							<th rowspan="2" class="col-1">{{ getMessage_('QWCC000038') }}</th>
							<td rowspan="2" class="col-4">
								<el-input
									type="textarea"
									:rows="4"
									:value="detailForm.vrfSbc"
									:show-word-limit="true"
									@input="val => setDetailForm(val, 'vrfSbc', 550)"
									:readonly="overInspect"
								/>
							</td>
							<!-- 파일첨부 -->
							<th rowspan="2">{{ getMessage_('QWCC000039') }}<br />{{ `(${getMessage_('QWCC000038')})` }}</th>
							<td rowspan="2" class="col-4">
								<template v-if="isLoaded">
									<file-upload-list
										id="vrfFileUpload"
										width="100%"
										height="100%"
										:propFileList="detailForm.vrfFileDb"
										:isEditable="!overInspect"
										maxQuantity="3"
										@MultiFile="vrfFileUpload"
										@onDownload="onDownloadFile"
									></file-upload-list>
								</template>
							</td>
							<!-- 검증결과 -->
							<th>{{ getMessage_('QWCC000040') }}</th>
							<td class="col-1">
								<sf-select-group
									labelPosition="left"
									:inputValue="detailForm.vrfRsltCd"
									:options="vrfRsltCdList"
									:onChange="val => setDetailForm(val, 'vrfRsltCd')"
									:placeholder="getMessage_('QWCC000040')"
									:disabled="overInspect"
								/>
							</td>
						</tr>
						<tr>
							<!-- 진행상태 -->
							<th>{{ getMessage_('QWCC001094') }}</th>
							<td>
								<sf-select-group
									labelPosition="left"
									:inputValue="detailForm.pgsStCd"
									:options="pgsStEmCdList"
									:placeholder="getMessage_('QWCC001127')"
									disabled
								/>
							</td>
						</tr>
						<tr>
							<!-- 비고 -->
							<th>{{ getMessage_('QWCC000906') }}<br />{{ `(${getMessage_('QWCC001447')})` }}</th>
							<td>
								<el-input
									type="textarea"
									:rows="4"
									:value="detailForm.rmk"
									:show-word-limit="true"
									:readonly="finAllStep"
									@input="val => setDetailForm(val, 'rmk', 90)"
								/>
							</td>
							<!-- 이력 -->
							<th>{{ getMessage_('SWCC000747') }}</th>
							<td colspan="3">
								<rmk-history :rmkHistory="rmkHistory"></rmk-history>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
import { getLimitedByteText } from '@/qmsUtils';
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@pqy/pcku/Eo4mApcn/store/helpers';
import FileUploadList from '@qms/Components/FileUploadList.vue';
import RmkHistory from './RmkHistory.vue';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			isLoaded: false
		};
	},
	components: { FileUploadList, RmkHistory },
	mounted() {
		this.isLoaded = true;
		this.setState_({ key: 'isSaved', value: false });
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		// overInspect() {
		// 	// 임시저장, 반려, 등록 상태 일 때,
		// 	return !this.isWriterSelf_ || this.detailForm.pgsStCd > 30;
		// },
		overInspect() {
			// 임시저장, 반려, 등록 상태 일 때,
			return this.detailForm.pgsStCd !=20;
		},
		finAllStep() {
			return this.detailForm.pgsStCd >= 40;
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		vrfFileUpload(saveList) {
			this.setDetailForm_({ key: 'vrfFile', value: saveList });
		},
		async onDownloadFile(file) {
			const { fileId, fileSeq } = file;
			await this.fileDownload_({ fileId, fileSeq });
		},
		setDetailForm(value, key, maxByte) {
			maxByte ? this.setDetailForm_({ key, value: getLimitedByteText(value, maxByte) }) : this.setDetailForm_({ key, value });
			this.setState_({ key: 'isSaved', value: true });
		}
	}
};
</script>
